
import React, { useState } from 'react';
import { MapPin } from 'lucide-react';
import { Button } from './button';
import { useLeafletMap } from '@/hooks/use-leaflet-map';
import MapLocationPicker from './map-location-picker';

interface LocationPickerButtonProps {
  latitude?: number;
  longitude?: number;
  onLocationSelect: (latitude: number, longitude: number) => void;
}

export const LocationPickerButton: React.FC<LocationPickerButtonProps> = ({ 
  latitude, 
  longitude, 
  onLocationSelect 
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { isLoaded, error } = useLeafletMap();
  
  const handleOpenDialog = () => {
    if (!isLoaded) {
      alert("Map is still loading. Please try again in a moment.");
      return;
    }
    
    if (error) {
      alert("Failed to load map. Please check your internet connection and try again.");
      return;
    }
    
    setIsDialogOpen(true);
  };
  
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="flex items-center gap-1"
        onClick={handleOpenDialog}
      >
        <MapPin className="h-4 w-4" />
        {latitude && longitude ? "Adjust Location" : "Set Location"}
      </Button>
      
      {isDialogOpen && (
        <MapLocationPicker
          open={isDialogOpen}
          onOpenChange={setIsDialogOpen}
          initialLatitude={latitude}
          initialLongitude={longitude}
          onLocationSelect={onLocationSelect}
        />
      )}
    </>
  );
};

export default LocationPickerButton;
